/*
 *
 * File JS Principale
 *
 */

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';
import 'swiper/css/bundle';
import 'lightgallery/css/lightgallery-bundle.min.css';
import 'lightgallery/css/lg-thumbnail.css';
//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require('webfontloader');
Webfont.load({
    google: {
        families: ['Montserrat:400,500,700&display=swap'],
    },
});

//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Libreria JS per l'output stilizzato per gli snippet di codice
//--------------------------------------------------------------------//

// import hljs from 'highlight.js';
// import 'highlight.js/styles/vs2015.css';
// hljs.highlightAll();

// let MobileDetect = require('mobile-detect');
// let md = new MobileDetect(window.navigator.userAgent);

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

import { initSvgImage } from './utilities/img-svg';
import smoothScroll from './utilities/smooth-scroll';
//--------------------------------------------------------------------//

// Init Utilies
//--------------------------------------------------------------------//

initSvgImage();

smoothScroll();

//--------------------------------------------------------------------//
